<template>
    <div class="page-menu-block" :class="{'in-menu' : inMenu}">
        <ul class="social-links margin-top-sm margin-bottom-lg" v-if="getOptions.social_links.instagram || getOptions.social_links.facebook || getOptions.social_links.youtube">
            <li class="item facebook"><a v-if="getOptions.social_links.facebook" :href="getOptions.social_links.facebook" rel="noopener" target="_blank" v-html="icons.facebook" /></li>
            <li class="item instagram"><a v-if="getOptions.social_links.instagram" :href="getOptions.social_links.instagram" rel="noopener" target="_blank" v-html="icons.instagram" /></li>
            <li class="item youtube"><a v-if="getOptions.social_links.youtube" :href="getOptions.social_links.youtube" rel="noopener" target="_blank" v-html="icons.youtube" /></li>
        </ul>
        <FancyBtn role="button" aria-label="Meny" title="Meny" @click.native="openMenu()" :type="inMenu ? 'dark' : 'green'" class="iconic menu-btn">
            <span class="txt jost jost--22 font--600">{{!inMenu ? 'Meny' : 'LUKK' }}</span>
            <span v-if="!inMenu" class="icon-menu" v-html="menuIcon()" />
            <span v-else class="icon-menu">
                <svg width="25" height="25" viewBox="0 0 25 25" xmlns="http://www.w3.org/2000/svg"><path fill="#FFF" d="M14.790374 12.4999258l9.7344976-9.73479401c.6335045-.633208.6335045-1.6570178 0-2.2902258-.633208-.63320799-1.6570178-.63320799-2.2902258 0l-9.7347941 9.73479411L2.76535421.474906c-.63350456-.633208-1.6570178-.633208-2.29022579 0-.63350456.63320799-.63350456 1.65701779 0 2.29022579L10.209626 12.4999258.47512842 22.2347199c-.63350456.633208-.63350456 1.6570178 0 2.2902258.31556594.3158625.73048772.4745353 1.14511293.4745353.41462514 0 .82925036-.1586728 1.14511286-.4745353l9.73449749-9.7347941 9.7347941 9.7347941c.3158625.3158625.7304877.4745353 1.1451129.4745353s.8292503-.1586728 1.1451129-.4745353c.6335045-.633208.6335045-1.6570178 0-2.2902258l-9.7344976-9.7347941z"/></svg>
            </span>
        </FancyBtn>
        
    </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import { search, menu } from '@/components/../icons';
import { instagram, youtube, facebook } from '@/components/../icons';
import FancyBtn from '@/components/elements/Button'


export default {
    name: 'page-menu',
    props: {
        // in %
        inMenu:{
            type: Boolean,
            default: false,
        }
    },
    methods:{
        ...mapMutations([
            'SEARCH_MODAL_CHANGE_STATE',
            'MENU_OPEN_CHANGE_STATE'
        ]),
        openSearch(){
            this.SEARCH_MODAL_CHANGE_STATE()
        },
        searchIcon(){
            return search('#005782')
        },
        menuIcon(){
            return menu('#005782')
        },
        openMenu(){
            this.MENU_OPEN_CHANGE_STATE()
        }
    },
    components:{
        FancyBtn
    },
    computed:{
        ...mapGetters([
            'mainNaviIsOpen',
            'searchModalOpen',
            'getOptions'
        ]),
        icons(){
            const icons = {
                facebook : facebook(),
                youtube : youtube(),
                instagram: instagram()
            }
            return icons
        }
    },
    
};
</script>


<style lang="scss">
@import "@/assets/vars.scss";
@import "@/assets/mixins.scss";
.page-menu-block{
    color: $dark;
    display: flex;
    .txt{
        text-transform: uppercase;
    }
    @include mquery($phone){
        .txt{
            display: none;
        }
    }
    .social-links{
        display: flex;
        list-style: none;
        margin: 0;
        padding: 0;
        svg{
            rect{
                fill: #fff;
                transition: fill 0.2s ease-in-out
            }
            path{
                fill: $dark;
                transition: fill 0.2s ease-in-out
            }
        }
        
        li{
            margin-right: 15px;
        }
        a{
            display: block;
            line-height: 1;
            height: 50px;
			@include mquery($phone){
                height: 30px;
            }

            &:hover{
                svg{
                    rect{
                        fill: $green;
                    }
                    path{
                        fill: $dark
                    }
                }
            }
            @include mquery($phone){
				svg{
					width: 30px;
					height: 30px;
				}
			}
        }
    }
    .menu-btn{
        span{
            line-height: 1;
        }
        
        &:hover{
            color: $dark;
        }
        .icon-menu{
            margin-left: 11px;
            margin-top: -4px;
            svg{
                height: 12px;
                width: 19px;
                rect{
                    fill: $dark
                }
            }
        }
        @include mquery($phone){
            padding: 8px 14px;
            height: 30px;
            .icon-menu{
                margin: 0;
                padding: 0;
                svg{
                    margin: 0;
                }
            }
            .txt{
                display: none;
            }
        }
        /* 
           
        } */
    }
}
</style>